import { types as mediasoupTypes } from "mediasoup-client";

export interface VideoOptions {
    WEB_APP_SERVER_URL: string;
    EMS_SERVER_URL: string;
    VIDEO_SERVER_URL: string;
    IS_PRODUCER: boolean;
}

declare global {
    interface Window {
        videoOptions: VideoOptions;
    }
}

export const videoOptions = window.videoOptions;

// maximum snapshot image chunk size for sending
export const MAX_CHUNK_SIZE = 12000;

// https://mediasoup.org/documentation/v3/mediasoup-client/api/#transport-produce
export const producerOptionsVideo: mediasoupTypes.ProducerOptions = {
  encodings: [
    { scaleResolutionDownBy: 4, maxFramerate: 15, maxBitrate: 500_000 },
    { scaleResolutionDownBy: 2, maxFramerate: 30, maxBitrate: 3_000_000 },
    { scaleResolutionDownBy: 1, maxFramerate: 30, maxBitrate: 8_000_000 },
  ],
  codecOptions: { videoGoogleStartBitrate: 1000 },
};
